// ── DRIPLABEL SCROLL REVEAL ──────────────────────────────
(function () {
  function initReveal() {
    const cards = document.querySelectorAll(
      '.product-grid__item, .rg-product-card, .cfb-product-card'
    );

    cards.forEach(function (card) {
      card.classList.add('drip-reveal');
    });

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    cards.forEach(function (card) {
      observer.observe(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();